import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ko from './ko';
import en from './en';

Vue.use(VueI18n);

const messages = { ko, en };
const LANGUAGE = {
    KOR: 'ko-KR',
    ENG: 'en-US'
}

let language;
language = navigator.language

const savedLocale = language === LANGUAGE.KOR ? 'ko' : 'en'

const i18n = new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages
});

Vue.prototype.$messages = messages;

export default i18n;